import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from 'reactstrap/lib/Button';
import { Link } from 'site-modules/shared/components/link/link';

const DEFAULT_HREF = '/';

export function GoButton({
  isDisabled = false,
  href = DEFAULT_HREF,
  text = 'Go',
  classes = 'px-1 py-0_5 ms-md-0_5 mb-1',
  buttonColor = 'success',
  textColor = 'text-white',
  rel = '',
}) {
  return (
    <Button
      disabled={isDisabled}
      color={buttonColor}
      tag={Link}
      to={href}
      className={classnames(classes, textColor, 'go-btn')}
      rel={rel}
    >
      {text}
    </Button>
  );
}

GoButton.propTypes = {
  href: PropTypes.string,
  text: PropTypes.string,
  isDisabled: PropTypes.bool,
  classes: PropTypes.string,
  buttonColor: PropTypes.string,
  textColor: PropTypes.string,
  rel: PropTypes.string,
};
